﻿export const AppContainerId = 'veilederinntektsavhengigstipend';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksBx = 'boks-bx';
export const BoksC = 'boks-c';
export const BoksResultat = 'resultat';
export const BoksTabell = 'tabell';
